import queries from '@apis/queries';
import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import {
    card, cardWrapper, container, hide, none,
} from './styles';

interface Props {
    userPrepaidCardId: string;
}
function Complete({ userPrepaidCardId }:Props) {
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLImageElement>(null);
    const { data } = useQuery(queries.userPrepaidCard.detail(userPrepaidCardId));
    const { t } = useTranslation('prepaidCard');
    useCompleteAnimation({
        ref, cardRef, imageUrl: data?.imageUrl, userPrepaidCardId,
    });
    return (
        <div className={`${container} ${none} ${hide}`}
            ref={ref}>
            <div className={cardWrapper}>
                <Image src={data?.imageUrl}
                    width={300}
                    height={200}
                    ref={cardRef}
                    className={card}
                    alt={t('orderComplete.cardImageAlt')} />
            </div>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    {t('orderComplete.complete')}
                </Text>
                <Text color={colors.gray7}>
                    {t('orderComplete.ready')}
                </Text>
            </Column>
        </div>
    );
}

export default Complete;
